import { useAuth } from '../../../global/contexts/auth/auth';
import { useRepositoriesList } from '../contexts/repositories';

import '../styles/repository-filter.css';

// The repository filter, once, next to the project one.
//
// A <select> and not a search: repositories are counted per project in single
// digits, and the list NARROWS WITH THE PROJECT (`project_id`), so choosing the
// project first leaves only its own. Without a project it lists the first 100,
// which is the cap.
//
// A chosen repository outside that page (or unreadable) still shows as
// `Repositorio #id`: a saved filter that reads as blank looks like no filter.
//
// Without `repositories:read` there is nothing to list: it renders nothing
// instead of a select that fails.

const LOOKUP_LIMIT = 100;

export default function RepositoryFilter({
    value,
    onChange,
    projectId,
    label = 'Repositorio',
    all = 'Todos los repositorios',
}) {
    const { can } = useAuth();
    const readable = can('repositories:read');
    const { data } = useRepositoriesList({ limit: LOOKUP_LIMIT, offset: 0, projectId });

    if (!readable) return null;

    const items = data?.items ?? [];
    const missing = value && !items.some(item => String(item.id) === String(value));

    return (
        <label className="repository-filter">
            <span className="repository-filter__label">{label}</span>
            <select
                className="repository-filter__select"
                value={value}
                onChange={e => onChange(e.target.value)}
            >
                <option value="">{all}</option>
                {missing && <option value={value}>Repositorio #{value}</option>}
                {items.map(item => (
                    <option key={item.id} value={item.id}>{item.name}</option>
                ))}
            </select>
        </label>
    );
}
